import { Context } from './context';
import { SimulationParam } from '../../shared/models/simulationParams';
import { SimulationData } from './simulationData';
import { ValidationConstants } from './validationconstants';
import { DeepLinkingModel } from '../../shared/models/DeeplinkParams';
import { BeneficiaryChild } from '../../shared/models/SurveyModel';
import { ResourceModel } from '../../shared/models/ResourceModel';
import { CaptureChildDetails } from '../../shared/models/CaptureChildDetails';
import { PromoValidatedData } from 'src/app/shared/models/PromoCodeModel';
import { OnlinePaymentEntryPage } from 'src/app/shared/models/Contract';

export class Session {
  public timestamp: number;
  public context: Context;
  public userParam: SimulationParam;
  public simulationData: SimulationData;
  public ValidationConstants: ValidationConstants;
  public BrokerInfo?: string;
  public isKnownBrokerFlow?: boolean;
  public clientName: string;
  public utm: {[key: string]: string};
  public PartnerInfo?: {IsPlanDistributor: boolean, Partner: string};
  public deeplinkParams? : DeepLinkingModel;
  public beneficiaryChild : BeneficiaryChild;
  public resource : ResourceModel[];
  public childDetails : CaptureChildDetails[];
  public validPromoDetails : PromoValidatedData;
  public OPCrypticInfo : string;
}
